export const Contact = (props) => {  
  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-8 col-md-offset-1 contact-info'>
            <div className='section-title'>
              <h2>Contato</h2>
            </div>
            <div className='contact-item'>
              <p className='contact-field'>
                <span>
                  <i className='fa fa-map-marker'></i> Endereço
                </span>
                {props.data ? props.data.address : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p className='contact-field'>
                <span>
                  <i className='fa fa-whatsapp'></i> Central de Atendimento
                </span>{' '}                
                <a href="https://wa.me/32998071731?text=Bem vindo(a) à nossa central de atendimento. Estamos à disposição para esclarecer quaisquer dúvidas." target="_blank" rel="noopener noreferrer" className="btn btn-wpp">{props.data ? props.data.wpp : 'loading'}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            &copy; 2021 Elo Assessoria e Sistemas Ltda.
          </p>
        </div>
      </div>
    </div>
  )
}
